import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Panel from '../../../../UniformComponents/Panel'
import PanelHeader from '../../../../UniformComponents/PanelHeader'
import Button from '../../../../UniformComponents/Button'
import Switch from '../../../../UniformComponents/Switch'
import Select from '../../../form/Select'

@observer
class ReportHeader extends Component {
    renderBenchmarkingBtn = (isMaxbiReport) => {
        if (isMaxbiReport) return null
        const { reportStore } = this.props
        const { showComparison, showBenchmarking } = reportStore

        if (process.env.USE_BENCHMARKING_MODAL) {
            return (
                <Button
                    label={i18n.t('benchmarkModal.buttonTitle')}
                    icon="fa-regular fa-retweet"
                    cssClass="regular tertiary"
                    onClick={() => {
                        reportStore.showBenchmarking = !showBenchmarking
                    }}
                />
            )
        }
        return (
            <Button
                label={i18n.t('report_comparison')}
                icon="fa-light fa-filter-list"
                cssClass="regular tertiary"
                onClick={() => {
                    reportStore.showComparison = !showComparison
                }}
            />
        )
    }

    render() {
        const { store, reportStore } = this.props
        const { survey } = store
        const isMaxbiReport = survey.isMaxbi()

        return (
            <Panel cssClass="reportHeader" style={{ overflow: 'unset' }}>
                <PanelHeader>
                    <div style={{ position: 'relative' }}>
                        <span>{survey.title}</span>
                        <div>
                            <div className="expandAll">
                                <Switch
                                    label={i18n.t('report_expand_pages')}
                                    state={Array.from(reportStore.openPages.values()).every((isOpen) => isOpen)}
                                    onToggle={reportStore.toggleAllPages}
                                />
                            </div>
                            <div className="locales">
                                <Select
                                    options={survey.metadata.locales.map((locale) => ({
                                        value: locale,
                                        label: '',
                                        src: `${process.env.CDN_URL}/includes/images/flags/${locale}.png`,
                                    }))}
                                    defaultValue={reportStore.locale}
                                    onBlur={({ value }) => { reportStore.locale = value }}
                                />
                            </div>
                            {this.renderBenchmarkingBtn(isMaxbiReport)}
                        </div>
                    </div>
                </PanelHeader>
            </Panel>
        )
    }
}

export default ReportHeader
